export const COLUMN_CHANGED_ANALYTIC_EVENT = "Column changed";
